import {
  EnumVisitStatus,
  EnumVisitVisitorStatus,
} from "../../lib/ground-aws-graphql-core/models/Api/Visits";

export const getVisitStatusBadgeColor = (status: EnumVisitStatus): string => {
  const map: Record<EnumVisitStatus, string> = {
    [EnumVisitStatus.PREREGISTERED]: "bg-ground-yellow-100",
    [EnumVisitStatus.CHECKED_IN]: "bg-ground-green-100",
    [EnumVisitStatus.CANCELED]: "bg-red-500",
    [EnumVisitStatus.CHECKED_OUT]: "bg-ground-blue-200",
  };

  return map[status] ?? "";
};

export const getVisitorStatusBadgeColor = (
  status: EnumVisitVisitorStatus
): string => {
  const map: Record<EnumVisitVisitorStatus, string> = {
    [EnumVisitVisitorStatus.CHECKED_IN]: "bg-ground-green-100",
    [EnumVisitVisitorStatus.CANCELED]: "bg-red-500",
    [EnumVisitVisitorStatus.CHECKED_OUT]: "bg-ground-blue-200",
  };

  return map[status] ?? "";
};

export const getVisitorInitials = (
  firstname?: string,
  lastname?: string
): string => {
  if (!firstname || !lastname) return "";

  return `${firstname[0]?.toUpperCase() ?? ""}${
    lastname[0]?.toUpperCase() ?? ""
  }`;
};
